const throttle = (fn: () => void, delay: number) => {
  let timeoutId = null;
  if (timeoutId !== null) {
    clearTimeout(timeoutId);
  }
  timeoutId = setTimeout(() => {
    fn();
  }, delay);
};

export default throttle;
